<template>
  <div class="row">
    <div class="col-12 mt-3">
      <div class="accordion account-collapse" role="tablist">
        <b-card
          v-if="hasNotifications"
          no-body
          :class="[{'border-bottom': !hasTodo}, 'bg-white', 'border-left', 'border-right', 'border-top']"
        >
          <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-2 d-flex justify-content-between align-items-center" role="tab">
            <div class="d-flex align-items-center">
              <b-badge class="rounded-circle mx-2" variant="primary">
                {{ notificationCount }}
              </b-badge> {{ $t('Notices') }}
            </div>
            <div>
              <font-awesome-icon class="mr-2" icon="angle-right" />
            </div>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body class="bg-white">
              <notification-block
                v-for="(notification, index) in notifications"
                :key="index"
                :notification="notification"
              />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="hasTodo && showSettings" no-body class="bg-white border">
          <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-2 d-flex justify-content-between align-items-center" role="tab">
            <div class="d-flex align-items-center">
              <b-badge class="rounded-circle mx-2" variant="primary">
                {{ Object.entries(todos).length }}
              </b-badge>
              {{ $t('To Do') }}
            </div>
            <div>
              <font-awesome-icon class="mr-2" icon="angle-right" />
            </div>
          </b-card-header>
          <b-collapse id="accordion-2" :visible="todosSelected" accordion="my-accordion" role="tabpanel">
            <b-card-body class="bg-white">
              <todo-card :todos="todos" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationBlock from "@/components/header/NotificationBlock";
import TodoCard from "@/components/section/Todo";
import companyAccount from "@/imports/mixins/companyAccount";

export default {
  name: "NotificationAccordion",
  components: {NotificationBlock, TodoCard},
  mixins: [companyAccount],
  props: ['todos', 'todosSelected'],
  data: function() {
    return {
      notificationsLoaded: false,
    }
  },
  computed: {
    notifications: function () {
      return this.$store.state.NOTIFICATIONS;
    },
    hasNotifications: function () {
      return (Array.isArray(this.notifications)) ? this.notifications.length > 0 : false;
    },
    notificationCount: function () {
      return this.notifications.length;
    },
    hasContent: function() {
      return (this.notification.content && this.notification.content.length > 0);
    },
    hasTodo: function() {
      return Object.entries(this.todos).length > 0;
    },
  }
}
</script>

<style scoped lang="scss">
.account-collapse {
  [role=tabpanel] {
    .card-body {
      border: 0;
    }
  }
  .badge {
    height: 16px;
    width: 16px;
    font-size: 55%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .not-collapsed {
    .svg-inline--fa {
      transition-duration: .3s;
      transition-property: transform;
      transform: rotate(90deg);
    }
  }

  .collapsed {
    .svg-inline--fa {
      transition-duration: .3s;
      transition-property: transform;
    }
  }
}

::v-deep .b-toast {
  margin: 0 auto;
  max-width: 460px;

  &:last-child {
    .toast {
      margin-bottom: 0;
    }
  }
  .toast {
    margin-bottom: 20px;
    max-width: 480px !important;

    .toast-body {
      padding: 0 0.75rem;
    }
  }
}
</style>
